export default __webpack_public_path__ + "static/media/ring.acfa1a1e.svg";